export const ENTITY = 'profile';
export const ENTITY_ACTIVITY = 'activities';
